
define('text!libs/strand/src/strand-localstore/example.html',[],function () { return '<template is="dom-bind">\n\t<strand-input value="{{value}}"></strand-input>\n\t<strand-localstore key="example" value="{{value}}"></strand-localstore>\n\t<template is="dom-if" if="{{!value}}">\n\t\t<div>After typing a value reload this page to see the value persisted.</div>\n\t</template>\n</template>';});

